<template>
  <div class="content md no-padding flex-box vertical">
    <BlockForm
      ref="blockForm"
      :initial="initial"
      class="block-form-box"
    ></BlockForm>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleConfirm">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import BlockForm from "./components/BlockForm.vue";

export default {
  name: "TabletBlockForm",
  components: {
    BlockForm,
  },
  data() {
    return {
      initial: { type: 1, num_type: 1 },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    isEdit() {
      return !!this.id;
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (this.id) {
        this.$axios(
          `/admin/memorial-tablet-block/${this.id}?expand=tabletBlockItem`
        ).then((res) => {
          this.initial = this.dealInfo(res);
        });
      }
    },
    dealInfo(res) {
      return res;
    },
    handleCancel() {
      this.$router.back();
    },
    handleConfirm() {
      this.$refs.blockForm.validate().then((form) => {
        if (this.isEdit) {
          form.id = Number(this.id);
        }
        // console.log("handleConfirm:", form);
        this.$axios({
          url: "/admin/memorial-tablet-block/create-block",
          method: "POST",
          data: form,
          noTempleFilter: true,
        }).then(() => {
          this.$message.success("保存成功");
          this.$store.commit("changeUpdate", { type: "tabletBlock" });
          this.$router.back();
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.block-form-box {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 16px 32px;
}
.footer {
  width: 100%;
}
</style>
